import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class OverlayTileColumn extends Component {
  static propTypes = {
    align: PropTypes.oneOf(['left', 'right']),
    children: PropTypes.node
  }

  static defaultProps = {
    align: 'left'
  }

  render() {
    const { align, children } = this.props

    const classes = classNames({
      'col-l': align === 'left',
      'col-r': align === 'right'
    })

    return <div className={classes}>{children}</div>
  }
}



// WEBPACK FOOTER //
// ../src/components/OverlayTileColumn.js